<template>
  <div>
    <modal name="editTaskModal" @closed="hideModal" width="950" height="auto" ref="editTask" class="editTask" style="overflow-y: scroll;">
      <div>
        <edit-task :is_modal_mode="true" :is_new_task="is_new_task" class="modal-content"></edit-task>
        <i
          @click="hideModal"
          class="fe fe-x closeModal"></i>
      </div>
    </modal>
  </div>
</template>

<script>
  import EditTask from '../components/base/EditTask';
  import { mapGetters } from 'vuex';

  export default {
    name: 'edit_task_modal',
    data () {
      return {
        is_new_task: false,
      };
    },
    computed: {
      ...mapGetters([
        'show_modal_edit_task',
        'selected_task',
      ]),
    },
    watch: {
      show_modal_edit_task: function () {
        if (this.show_modal_edit_task) {
          this.is_new_task = false;
          this.$modal.show('editTaskModal');
        }
        this.getPath(this.show_modal_edit_task);
      },
    },

    methods: {
      getPath (task) {
        const path = this.$route.path.match(/^\/[A-Za-z0-9]+/)[0]; // getting only path if page

        const replacePath = task ? `${path}/${this.selected_task._id}` : path;

        window.history.replaceState(null, null, `${replacePath}`);
      },
      hideModal () {
        this.$store.commit('hideModal', 'edit_task');
        this.getPath(this.show_modal_edit_task);
        this.$modal.hide('editTaskModal');
      },
    },
    components: {
      EditTask,
    },

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .editTask {
    cursor: pointer;
  }

  .modal-content {
    cursor: default;
  }

  .closeModal {
    font-size: 2em;
    color: #ffffff;
    position: fixed;
    top: 17px;
    right: 27px;
    z-index: 1000;
    cursor: pointer;
  }

</style>
